const desc = (a, b, orderBy) => {
	// if (orderBy === "username") {
	// 	if (b < a) return 1
	// 	if (b > a) return -1
	// } else {
	if (b[orderBy] < a[orderBy]) return 1
	if (b[orderBy] > a[orderBy]) return -1
	// }
	return 0
}

export const stableSort = (array, cmp, orderBy) => {
	// if (orderBy === "username") {
	// 	const stabilizedThis = array.map((el, index) => [el, index])
	// 	const returnSorted = stabilizedThis.sort((a, b) => {
	// 		const accElement = a[0].user.given_name
	// 		const compareElement = b[0].user.given_name
	// 		const order = cmp(accElement, compareElement)
	// 		if (order !== 0) return order
	// 		return a[1] - b[1]
	// 	})
	// 	return returnSorted.map(el => el[0])
	// } else {
	const stabilizedThis = array.map((el, index) => [el, index])
	stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0])
		if (order !== 0) return order
		return a[1] - b[1]
	})
	return stabilizedThis.map(el => el[0])
	// }
}

export const getSorting = (order, orderBy) => {
	return order === "desc"
		? (a, b) => desc(a, b, orderBy)
		: (a, b) => -desc(a, b, orderBy)
}

export const compare = (a, b) => {
	if (a.project_likes.length > b.project_likes.length) return -1
	if (b.project_likes.length > a.project_likes.length) return 1

	return 0
}

export const comparenoti = (a, b) => {
	if (a.date_time > b.date_time) return -1
	if (b.date_time > a.date_time) return 1

	return 0
}
